<template>
  <sweet-modal ref="modal" id="config-fields-modal" width="60w" :title="$t('ct-custom-sizes-title')" @close="close()">
    <sweet-modal-tab :title="$t(`ct-desktop`)" id="desktop">
      <ConfigFieldsDevice type="desktop" :paddings="paddings" :options="options" :object="object" icon="desktop" @copy="copySettingsFromDesktop"/>
    </sweet-modal-tab>
    <sweet-modal-tab :title="$t(`ct-mobile`)" id="mobile">
      <ConfigFieldsDevice type="mobile" :paddings="paddings" :options="options" :object="objectMobile" icon="mobile-alt" @copy="copySettingsFromDesktop"/>
    </sweet-modal-tab>

    <button slot="button" class="btn btn-default right" @click="closeModal()">{{ $t('ct-cancel') }}</button>
    <button slot="button" class="btn btn-success right" @click="trocar()"><i
      class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal, SweetModalTab} from "sweet-modal-vue";
import ConfigFieldsDevice from "./ConfigFieldsDevice";

export default {
  name: "configFieldsComponent",
  components: {
    SweetModal, SweetModalTab,
    ConfigFieldsDevice
  },
  props: [],
  data() {
    return {
      fields: [],
      callback: '',
      internal_config: 0,
      object: {
        custom: true,
        container: {width: 50},
        btnPlace: {width: 50, padding: 15},
        fields: []
      },
      objectMobile: {
        custom: true,
        container: {width: 50},
        btnPlace: {width: 50, padding: 15},
        fields: []
      },
      savedConfig: {
        fields: []
      },
      savedConfigMobile: {
        fields: []
      },
      options: [],
      paddings: [],
    };
  },
  methods: {
    init(fields, saved, callback, horizontal_config_mobile) {
      this.object.fields = [];
      this.objectMobile.fields = [];
      this.savedConfig = saved;
      this.savedConfigMobile = horizontal_config_mobile;

      this.callback = callback;
      this.fields = fields;

      this.fields.forEach((field) => {
        this.object.fields.push({name: field.tag, size: 'col-12'})
        this.objectMobile.fields.push({name: field.tag, size: 'col-12'})
      })

      this.options = [];
      let start_option = 50;
      let end_option = 90;
      let step_options = 5;
      let i = start_option

      for (; i <= end_option; i += step_options) {
        this.options.push(i);
      }

      i = 0;

      this.paddings = [];

      for (; i <= 150; i += 5) {
        this.paddings.push(i);
      }

      this.bindValues();
    },
    bindValues() {

      this.object.container = this.savedConfig.container;
      this.object.btnPlace = this.savedConfig.btnPlace;
      this.object.custom = this.savedConfig.custom;

      this.savedConfig.fields.forEach((field) => {
        this.object.fields.forEach((fieldFOrm) => {
          if (field.name === fieldFOrm.name) {
            fieldFOrm.size = field.size
          }
        })
      })

      this.objectMobile.container = this.savedConfigMobile.container;
      this.objectMobile.btnPlace = this.savedConfigMobile.btnPlace;
      this.objectMobile.custom = this.savedConfigMobile.custom;

      this.savedConfigMobile.fields.forEach((field) => {
        this.objectMobile.fields.forEach((fieldFOrm) => {
          if (field.name === fieldFOrm.name) {
            fieldFOrm.size = field.size
          }
        })
      })

      // console.log('this.objectMobile.fields savedConfigMobile', this.objectMobile.fields, this.savedConfigMobile.fields);

    },
    openModal() {

      this.$refs.modal.open();

    },
    trocar() {
      this.callback(this.object, this.objectMobile);
      this.closeModal();
    },
    closeModal() {
      this.$refs.modal.close();

    },
    close() {
      document.querySelectorAll(".handle").forEach(e => {
        if (e.style.zIndex == -1) {
          e.style.zIndex = "auto";
        }
      });
    },
    copySettingsFromDesktop() {
      this.objectMobile = JSON.parse(JSON.stringify(this.object));
    }
  }
};
</script>

<style lang="scss">
#config-fields-modal {
  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #434343;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
    color: #434343;

    svg {
      margin-right: .5em;
    }
  }

  input.form-control {
    height: 38px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/ConfigFields.vue